import type {ValueOf} from '@myparcel-frontend/types';
import {TierName} from '@/types/subscriptions/tiers';

export const MyScanAndPrintProductId = {
  Premium: 4732,
  Max: 4733,
} as const;

export const MyScanAndPrintTierName = {
  Premium: TierName.Premium,
  Max: TierName.Max,
} as const;

export const MY_SCAN_AND_PRINT_IDS_TO_NAMES = {
  [MyScanAndPrintProductId.Premium]: MyScanAndPrintTierName.Premium,
  [MyScanAndPrintProductId.Max]: MyScanAndPrintTierName.Max,
};

export const MY_SCAN_AND_PRINT_NAMES_TO_IDS = {
  [MyScanAndPrintTierName.Premium]: MyScanAndPrintProductId.Premium,
  [MyScanAndPrintTierName.Max]: MyScanAndPrintProductId.Max,
};

export const toMyScanAndPrintTierName = <T extends ValueOf<typeof MyScanAndPrintProductId>>(id: T) => {
  return MY_SCAN_AND_PRINT_IDS_TO_NAMES[id];
};

export const toMyScanAndPrintProductId = <T extends ValueOf<typeof MyScanAndPrintTierName>>(name: T) => {
  return MY_SCAN_AND_PRINT_NAMES_TO_IDS[name];
};
